import { useMemo } from "react";

import { getRentalAccountsForSub } from "features/subscriptions/helpers/rentalSubscriptions";

import { Tag } from "common/components/ui/Tag";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

import AccountAvatarsTooltip from "../AccountAvatarsTooltip";

interface AccountsProps {
  subscriptionId: string;
  rentedCount: number;
}

export default function Accounts({
  subscriptionId,
  rentedCount,
}: AccountsProps) {
  const { accounts } = useSelectedWorkspaceContext();

  const rentedAccounts = useMemo(
    () => getRentalAccountsForSub(accounts, subscriptionId),
    [accounts, subscriptionId],
  );

  return (
    <div className="flex flex-col gap-y-2.5 items-start">
      <div className="flex items-center gap-x-1">
        <h5 className="text-sm-medium text-black-500">Avatars</h5>
      </div>

      <div className="flex flex-row gap-2 items-center">
        <Tag variant="tertiary">{rentedCount}</Tag>

        <AccountAvatarsTooltip
          accounts={rentedAccounts}
          totalCount={rentedCount}
        />
      </div>
    </div>
  );
}
